import { useQueryClient } from '@tanstack/react-query';

import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { remove } from '../../../redux/api';

import { TRUST_RELATIONSHIPS_QUERY_KEY } from './useTrustRelationships';

/**
 * Hook to delete an OIDC trust relationship.
 * Automatically invalidates the trust relationships cache on success.
 * Displays success/error toasts automatically.
 */
export default function useDeleteTrustRelationship() {
  const queryClient = useQueryClient();

  return useToastedMutation({
    mutationFn: async (trustRelationshipId: number) => {
      await remove(`/api/oidc/trust-relationships/${trustRelationshipId}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [TRUST_RELATIONSHIPS_QUERY_KEY] });
    },
    successToastMessage: 'Trust relationship deleted successfully',
    errorToastMessage: 'Failed to delete trust relationship',
  });
}
